import { css } from '@emotion/react'

const font = {
   regular: css`
      font-family: 'Circular Std Medium', Helvetica, Arial, sans-serif;
      font-style: normal;
      font-weight: 400;
      line-height: 1.3;
   `,
   regularItalic: css`
      font-family: 'Circular Std Medium Italic', Helvetica, Arial, sans-serif;
      font-style: italic;
      font-weight: 400;
      line-height: 1.3;
   `,

   thin: css`
      font-family: 'Circular Std Book', Helvetica, Arial, sans-serif;
      font-style: normal;
      font-weight: 300;
      line-height: 1.3;
   `,
   thinItalic: css`
      font-family: 'Circular Std Book Italic', Helvetica, Arial, sans-serif;
      font-style: italic;
      font-weight: 300;
      line-height: 1.3;
   `,
   bold: css`
      font-family: 'Circular Std Bold', Helvetica, Arial, sans-serif;
      font-style: normal;
      font-weight: 700;
      line-height: 1.3;
   `,
   boldItalic: css`
      font-family: 'Circular Std Bold Italic', Helvetica, Arial, sans-serif;
      font-style: italic;
      font-weight: 700;
      line-height: 1.3;
   `,
}

export default font
